import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, useAttrs, ref } from 'vue';
import DynamicTableOriginal from 'ah-common-lib/src/common/components/listing/DynamicTable.vue';
import { ListResponse } from 'ah-api-gateways';
import { RequestState } from 'ah-requests';
import { TableFieldDefinition } from 'ah-common-lib/src/models';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import InfoTooltip from 'bd-common/src/components/common/InfoTooltip.vue';
import WarningSplash from '../common/WarningSplash.vue';
import LoadingSplash from '../common/LoadingSplash.vue';
import { useTradeState } from '../../../../ah-trades/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'BDDynamicTable',
  props: {
  data: {
    type: Object as PropType<ListResponse<any> | null>,
    default: null,
  },
  dataLoadState: {
    type: String as PropType<RequestState>,
    default: 'idle',
  },
  selectedItems: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
  withRowDetails: {
    type: [Boolean, String, Function],
    default: false,
  },
  withRowSubView: {
    type: [Boolean, String, Function],
    default: false,
  },
  clickableRow: {
    type: [Boolean, String, Function],
    default: false,
  },
  animateCols: {
    type: [Boolean, String],
    default: false,
  },
  rowClass: {
    type: [String, Function],
    required: false,
  },
  itemsLabel: {
    type: String,
    default: 'items',
  },
  noResultsHeading: {
    type: String,
    default: 'No items found',
  },
  noResultsText: {
    type: String,
    default: '',
  },
  primaryKey: {
    type: String,
    default: 'id',
  },
  /**
   * Whether to use flex scroll
   *
   * Flex scroll requires setting 'flex-basis' values for every column
   * Please refer to PrimeVue documentation
   */
  withFlexScroll: {
    type: [String, Boolean],
    default: false,
  },
  /**
   * Whether to use 'simple' scroll - overriden by `withFlexScroll`
   *
   * In this mode, fixed columns are not possible (will simply add a overflow: auto to the wrapping element)
   */
  withSimpleScroll: {
    type: [String, Boolean],
    default: false,
  },
  /**
   * Whether to use a shadow on the expanded row
   */
  withShadowedExpandedRows: {
    type: [String, Boolean],
    default: true,
  },
},
  emits: {
  'open-row-subview': (_item: any) => true,
},
  setup(__props, { emit }) {

const props = __props;

/**
 * Replaces DynamicTable from common-lib, including some default templates for sorting and toggling
 *
 * MUST be imported into Vue as "DynamicTable" to effectively replace the base implementation
 */




const attrs = useAttrs();

const expandedRows = ref<string[]>([]);

const table = ref<DynamicTableOriginal | null>(null);

const tableFields = computed(() => {
  const fields: TableFieldDefinition[] = [...((attrs.fields as any) || [])];

  if (props.withRowDetails !== false) {
    fields.push({
      header: '',
      key: 'expandableRowToggle',
      class: 'toggle-col',
      sortable: false,
    });
  }
  if (props.withRowSubView !== false) {
    fields.push({
      header: '',
      key: 'selectableToggle',
      class: 'toggle-col',
      sortable: false,
    });
  }

  return fields;
});

function hasDetailsOpen(item: any) {
  return item[props.primaryKey] && expandedRows.value.includes(item[props.primaryKey]);
}

function hasRowDetails(item: any) {
  return typeof props.withRowDetails === 'function' ? props.withRowDetails(item) : props.withRowDetails !== false;
}

function isClickable(item: any) {
  return typeof props.clickableRow === 'function' ? props.clickableRow(item) : props.clickableRow !== false;
}

function bdRowClass(item: any, type: any) {
  const classes = [];
  if (props.rowClass) {
    classes.push(typeof props.rowClass === 'function' ? props.rowClass(item, type) : props.rowClass);
  }

  if (props.selectedItems.includes(item[props.primaryKey])) {
    classes.push('selected-row');
  }

  if (hasDetailsOpen(item)) {
    classes.push('b-table-has-details');
  }

  if (hasRowDetails(item)) {
    classes.push('with-details');
  }

  if (isClickable(item)) {
    classes.push('clickable');
  }

  return classes.join(' ');
}
const tradeState = useTradeState();

function infoText(infoText?: string) {
  return infoText ? (tradeState.i18n.t(infoText) as string) : '';
}

return { __sfc: true,props, emit, attrs, expandedRows, table, tableFields, hasDetailsOpen, hasRowDetails, isClickable, bdRowClass, tradeState, infoText, DynamicTableOriginal, MaterialIcon, InfoTooltip, WarningSplash, LoadingSplash }
}

})